import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-workplace-safety',
  templateUrl: './workplace-safety.component.html',
  styleUrls: ['./workplace-safety.component.css']
})
export class WorkplaceSafetyComponent implements OnInit {

  updated: false

  constructor(private authServ: AuthService) { }

  ngOnInit(): void {
    this.updateLastVisit();
  }

  updateLastVisit() {
    let d = new Date();

    let updater = { "wvpp_view_date": d.toISOString() };
    this.authServ.updateUser(updater)
      .subscribe(res => {
      },
        err => {

        });
  }
}
